<template>
  <div>
    <h3>Обработка входа...</h3>
  </div>
</template>


<script>
export default {
  name: 'SberIdCallback',
  methods: {
    async waitForSocket(store, timeout = 5000) {
      return new Promise((resolve, reject) => {
        if (store.state.connected) return resolve()

        const start = Date.now()
        const interval = setInterval(() => {
          if (store.state.connected) {
            clearInterval(interval)
            resolve()
          } else if (Date.now() - start > timeout) {
            clearInterval(interval)
            reject(new Error('Socket connection timeout'))
          }
        }, 100)
      })
    }
  },
  async created() {
    try {
      const hash = window.location.hash
      const idx = hash.indexOf('?')
      const queryString = idx !== -1 ? hash.slice(idx + 1) : hash.slice(1)
      const params = new URLSearchParams(queryString)
      const code = params.get('code')
      const state = params.get('state')
      if (!code || !state) {
        throw new Error('Missing code or state')
      }
      const savedState = sessionStorage.getItem('sberid_state')
      if (savedState && savedState !== state) {
        throw new Error('State mismatch')
      }
      await this.waitForSocket(this.$store)
      const { profile, meta } = await this.$store.dispatch('sioRequest', {
        topic: 'auth-login-sber-id-callback',
        pl: {
          code,
          state
        }
      })
      this.$store.dispatch('snack', meta.msg)
      this.$store.dispatch('sberlogin', { profile, meta })
    } catch (err) {
      this.$store.dispatch('snack', err)
      console.error('Callback error', err)
      this.$router.replace({ name: 'login', query: { error: 'sberid_failed' } })
    }
  }
}
</script>